import { riskManagementResourceAdapter } from './RiskManagement.resource';
export function liquidityMakerResource(data) {
    var broker = {
        id: data.account.broker.id,
        name: data.account.broker.name,
        separator: data.account.broker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var account = {
        id: data.account.id,
        name: data.account.name,
        key: data.account.key,
        secret: data.account.secret,
        passphrase: data.account.passphrase,
        broker: broker,
        pair: data.account.pair,
        main: data.account.main,
        client: data.account.client,
        type: data.account.type,
        mainAccount: data.account.mainAccount
    };
    var priceStep = {
        type: data.priceStep.type,
        bid: data.priceStep.bid,
        asc: data.priceStep.asc
    };
    var sumStep = {
        type: data.sumStep.type,
        bid: data.sumStep.bid,
        asc: data.sumStep.asc
    };
    var pair = {
        id: data.pair.id,
        name: data.pair.name,
        baseCurrency: data.pair.baseCurrency,
        quoteCurrency: data.pair.quoteCurrency,
        maxSum: data.pair.maxSum,
        broker: broker,
        restartMaxTimeValue: data.pair.restartMaxTimeValue,
        minQuantity: data.pair.minQuantity
    };
    var hedging = data.hedging ? {
        use: data.hedging.use,
        id: data.hedging.id,
        algorithm: data.hedging.algorithm,
        account: data.hedging.account,
        pair: data.hedging.pair,
        coverType: data.hedging.coverType,
        coverValue: data.hedging.coverValue
    } : null;
    var riskManagement = riskManagementResourceAdapter(data.riskManagement);
    return {
        id: data === null || data === void 0 ? void 0 : data.id,
        countOrderBid: data.countOrderBid,
        countOrderAsc: data.countOrderAsc,
        active: data.active,
        startedAt: data.startedAt,
        useWebSocket: data.useWebSocket,
        statuses: data.statuses,
        account: account,
        priceStep: priceStep,
        sumStep: sumStep,
        pair: pair,
        hedging: hedging,
        riskManagement: riskManagement,
        openOutSide: data.openOutSide,
        doubleFirstStep: data.doubleFirstStep,
        avgBidAsc: data.avgBidAsc,
        canOpenByTradePrice: data.canOpenByTradePrice,
        triggeredIncomeTrade: data.triggeredIncomeTrade,
        triggeredIncomeTradeTime: data.triggeredIncomeTradeTime,
        countOrdersBySecond: data.countOrdersBySecond,
        delayOrder: data.delayOrder,
        countOrdersWithoutTrades: data.countOrdersWithoutTrades
    };
}
